const ROL_PRIORIDAD = [
  'admin-platform', 'admin-tenant', 'medico', 'enfermeria', 'recepcion',
  'farmacia', 'laboratorio', 'imagenologia', 'quirofano', 'caja',
  'contabilidad', 'tesoreria', 'bodega', 'nomina', 'mspas', 'auditoria',
  'consultorio-externo', 'vet-medico', 'vet-recepcion', 'vet-farmacia',
  'optica-optometrista', 'optica-recepcion', 'optica-ventas',
] as const;

export type DashboardRole =
  | 'admin' | 'enfermeria' | 'medico' | 'recepcion'
  | 'farmacia' | 'laboratorio' | 'imagenologia' | 'quirofano' | 'caja'
  | 'finanzas' | 'mspas' | 'auditoria' | 'generico';

const MAP: Record<string, DashboardRole> = {
  'admin-platform': 'admin',
  'admin-tenant': 'admin',
  enfermeria: 'enfermeria',
  medico: 'medico',
  recepcion: 'recepcion',
  farmacia: 'farmacia',
  laboratorio: 'laboratorio',
  imagenologia: 'imagenologia',
  quirofano: 'quirofano',
  caja: 'caja',
  contabilidad: 'finanzas',
  tesoreria: 'finanzas',
  bodega: 'finanzas',
  nomina: 'finanzas',
  mspas: 'mspas',
  auditoria: 'auditoria',
};

export function resolveDashboardRole(roles: string[] | undefined): DashboardRole {
  if (!roles?.length) return 'admin';
  for (const r of ROL_PRIORIDAD) {
    if (roles.includes(r) && MAP[r]) return MAP[r];
  }
  return 'generico';
}

export const DASHBOARD_TITLES: Record<DashboardRole, string> = {
  admin: 'Centro de comando',
  enfermeria: 'Unidad de cuidados',
  medico: 'Atención clínica',
  recepcion: 'Front desk',
  farmacia: 'Dispensación',
  laboratorio: 'Laboratorio (LIS)',
  imagenologia: 'Imagenología (RIS)',
  quirofano: 'Block quirúrgico',
  caja: 'Caja y cobros',
  finanzas: 'Finanzas',
  mspas: 'Indicadores MSPAS',
  auditoria: 'Auditoría',
  generico: 'Inicio',
};

/** Todos los dashboards implementados (doc §13). */
export const ALL_DASHBOARD_ROLES: DashboardRole[] = [
  'admin', 'enfermeria', 'medico', 'recepcion', 'farmacia',
  'laboratorio', 'imagenologia', 'quirofano', 'caja', 'finanzas',
  'mspas', 'auditoria',
];
